module.exports = __webpack_public_path__ + "img/homefounder-logo.svg";